<script setup>
/**
 * Este objeto hay que meterlo dentro de un objeto Tabla para que le provea
 * de los datos necesarios
 */
import { inject } from 'vue';
import { debounce } from 'lodash';

const props = defineProps({
  // Nombre del campo para filtrar
  campo: { type: String, required: true },
  valores: { type: Array, default: () => [] },
});

// Tabla nos publica este objeto reactivo
const filtros = inject('filtros');

function cambiaValor(event) {
  // Actualizamos el filtro con el valor seleccionado
  filtros[props.campo] = event.target.value;
}

// Creamos la función debounced una sola vez
const debouncedCambiaValor = debounce(cambiaValor, 150);
</script>

<template>
  <th>
    <input
      :name="campo"
      :value="filtros[props.campo] || ''"
      @keyup="debouncedCambiaValor"
    />
  </th>
</template>

<style scoped lang="scss">
@import "@/../assets/stylesheets/cifra/vars/main.scss";

th {
  white-space: nowrap;
  select {
    font-weight: normal;
  }
}
</style>
